function tempPrintData() {
    console.log("TESTING : CONSOLE LOG DATA");
}

// Function to set the primary language
function setPrimaryLanguage(language) {
    console.log(`Language picked: ${language}`);
    // Set the primary language (for example, storing it in a variable or localStorage)
    let primary_language = language;

    // If you want to store it in localStorage for persistence
    localStorage.setItem('primary_language', primary_language);

    // Return the primary language (optional)
    return primary_language;
}

// Function to log the time when the user selected the current language
function logLanguageSelect() {
    let current_language = localStorage.getItem('primary_language');
    let selection_time = localStorage.getItem('selection_time');

    if (current_language && selection_time) {
        console.log(`The language "${current_language}" was selected at: ${selection_time}`);
    } else {
        console.log('No language has been selected yet.');
    }
}


